import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'red',
      },
      '&:hover fieldset': {
        borderColor: 'yellow',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'green',
      },
    },
  },
})(TextField);


//estilo
const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
});
 class ChangePassword extends Component {
  static propTypes = {

  };
  constructor(props) {
    super(props)
    this.state = {
       oldPassword:"",
       newPassword:"", 
       confirmNewPassword:"",
       errores:{
         oldpassword:true, 
         newpassword:true, 
         confirmnewpassword:true,
       }
    }
    this.handleChange=this.handleChange.bind(this)
    this.updatePassword= this.updatePassword.bind(this)
  }
  
  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let errores=this.state.errores
    errores[name]=value.trim()===""
    if(name==="oldpassword"){
      this.setState({
        oldPassword:value,
        errores:errores
      })
    }else if(name==="newpassword"){
      this.setState({
        newPassword:value,
        errores:errores
      })
    }else if(name==="confirmnewpassword"){
      errores.confirmnewpassword=value.trim()===this.state.newPassword.trim()?false:true
      this.setState({
        confirmNewPassword:value, 
        errores:errores
      })
    }
  }
  updatePassword=()=>{
    this.props.setLoadingPassword()
    this.props.updatePassword({
      oldPassword:this.state.oldPassword, 
      newPassword:this.state.newPassword
    })
  }
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
        {this.props.loadingChangePassword? 
            <Paper className={classes.paper}>              
              {this.props.changePasswordStatus===null?
                <div>
                  <Typography align="center">
                    Loading
                  </Typography>
                  <div style={{textAlign:"center"}}>
                    <CircularProgress number={100}/>
                  </div>
                </div>
                :
                this.props.changePasswordStatus===1?
                <span style={{color:"green", fontSize:"0.8em", marginLeft:"3%"}}>Your password has been updated</span>
                :
                <span style={{color:"red", fontSize:"0.8em", marginLeft:"3%"}}>The old password is wrong. Try again.</span>
              }
              
            </Paper>
            : 
            <Paper className={classes.paper}>
              <Typography component="h1" variant="h4" align="center">
                  Password update
              </Typography>            
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12}>
                  <CssTextField
                    required
                    id="oldpassword"
                    name="oldpassword"
                    label="Old password"
                    type="password"
                    fullWidth
                    onChange={this.handleChange}
                    value={this.state.oldPassword}
                    error={this.state.errores.oldpassword?true:false}
                  />
                </Grid>
                <span style={{color:"red", fontSize:"0.8em", marginLeft:"3%"}}>{this.state.errores.oldpassword?"Required field":""}</span>
                <br/>
                <br/>
                <Grid item xs={12} sm={12}>
                  <CssTextField
                    required
                    id="newpassword"
                    name="newpassword"
                    label="New Password"
                    fullWidth
                    type="password"
                    onChange={this.handleChange}
                    value={this.state.newPassword}
                    error={this.state.errores.newpassword?true:false}
                  />
                </Grid>
                <span style={{color:"red", fontSize:"0.8em", marginLeft:"3%"}}>{this.state.errores.newpassword?"Required field":""}</span>
                <br/>
                <br/>
                <Grid item xs={12} sm={12}>
                  <TextField
                    required
                    id="confirmnewpassword"
                    name="confirmnewpassword"
                    label="Confirm new password."
                    fullWidth
                    type="password"
                    onChange={this.handleChange}
                    value={this.state.confirmNewPassword}
                    error={this.state.errores.confirmnewpassword?true:false}
                  />
                </Grid>
                <span style={{color:"red", fontSize:"0.8em", marginLeft:"3%"}}>{this.state.errores.confirmnewpassword?"The new password and password confirmation don't match.":""}</span>
                <br/>
              </Grid>
              <Button
              variant="contained"
              color="primary"
              className={classes.button}
              disabled={this.state.errores.oldpassword || this.state.errores.newpassword || this.state.errores.confirmnewpassword}
              onClick={this.updatePassword}
              > 
                save new password
              </Button>
            </Paper>        
            }
          </main>
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ChangePassword));


// WEBPACK FOOTER //
// ./src/features/profile/ChangePassword.js